import React from "react";
import { motion } from "framer-motion";

const stats = [
  { value: "1,200+", label: "Doctors Trusted", detail: "Active prescribers across India" },
  { value: "4", label: "Therapeutic Areas", detail: "Psychiatry · Ortho · Neuro · GM" },
  { value: "15+", label: "Years Experience", detail: "Founders with deep industry expertise" },
  { value: "50+", label: "Cities Reached", detail: "Distribution across Tier 1–3 cities" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="py-24 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="overline mb-3">Numbers that ground us</div>
            <h2 className="font-display text-3xl sm:text-5xl tracking-tighter font-medium max-w-2xl leading-[1.05]">
              A young company, with the depth of a seasoned one.
            </h2>
          </div>
          <p className="md:max-w-sm text-[var(--mp-text-2)] leading-relaxed">
            Built by people who have spent careers inside India's largest pharma houses — now
            channelled into one focused mission.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[var(--mp-border)] border border-[var(--mp-border)] rounded-2xl overflow-hidden">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-white p-7 md:p-10 group hover:bg-[var(--mp-accent-surface)]/40 transition-colors duration-300"
              data-testid={`stat-card-${i}`}
            >
              <div className="font-mono-display text-[10px] tracking-[0.25em] uppercase text-[var(--mp-text-2)] mb-4">
                0{i + 1} / 04
              </div>
              <div className="font-display text-4xl md:text-5xl font-medium tracking-tighter text-[var(--mp-text)]">
                {s.value}
              </div>
              <div className="mt-3 text-sm font-medium text-[var(--mp-text)]">{s.label}</div>
              <div className="text-xs text-[var(--mp-text-2)] mt-1">{s.detail}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
